var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    id: "telegram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.5,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#80D8FF",
    d: "M30.5,16c0-1.339-0.196-2.631-0.536-3.862C27.83,6.787,22.612,3,16.5,3C8.492,3,2,9.492,2,17.5 c0,1.339,0.196,2.631,0.536,3.862C4.67,26.713,9.888,30.5,16,30.5C24.008,30.5,30.5,24.008,30.5,16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M15.737,31C7.474,31,1,24.411,1,16c0-3.629,1.237-7.111,3.485-9.804c0.178-0.212,0.492-0.239,0.704-0.063 C5.401,6.31,5.43,6.625,5.253,6.837C3.155,9.35,2,12.604,2,16c0,7.851,6.034,14,13.737,14C23.602,30,30,23.72,30,16 S23.602,2,15.737,2c-2.44,0-4.813,0.62-6.858,1.792C8.642,3.925,8.334,3.846,8.197,3.606C8.06,3.366,8.143,3.061,8.383,2.923 C10.579,1.665,13.122,1,15.737,1C24.153,1,31,7.729,31,16S24.153,31,15.737,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M7.543,4.552c0,0.275-0.225,0.5-0.5,0.5l0,0c-0.275,0-0.5-0.225-0.5-0.5l0,0 c0-0.275,0.225-0.5,0.5-0.5l0,0C7.318,4.052,7.543,4.276,7.543,4.552L7.543,4.552z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF1",
    d: "M13.25,22.875c-0.486,0-0.403-0.184-0.571-0.646l-1.429-4.703l11-6.526L13.25,22.875z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M13.25,22.875c0.375,0,0.541-0.171,0.75-0.375l2-1.945l-2.495-1.504L13.25,22.875z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.505,19.051l6.045,4.466c0.69,0.38,1.188,0.183,1.359-0.641l2.461-11.595 c0.252-1.01-0.385-1.468-1.045-1.169L7.876,15.685c-0.986,0.396-0.979,0.946-0.18,1.191l3.708,1.157l8.584-5.416 c0.405-0.246,0.777-0.114,0.473,0.157L13.505,19.051z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M19.55,24.018c-0.111,0-0.224-0.037-0.316-0.113l-5.763-4.721c-0.113-0.092-0.18-0.229-0.184-0.375 c-0.003-0.146,0.057-0.285,0.165-0.383l4.277-3.86c0.205-0.187,0.521-0.169,0.706,0.036c0.186,0.205,0.169,0.521-0.036,0.706 l-3.846,3.47l5.313,4.353c0.214,0.175,0.245,0.49,0.07,0.704C19.838,23.955,19.694,24.018,19.55,24.018z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M20.157,24.204L20.157,24.204c-0.265,0-0.55-0.083-0.849-0.248l-3.286-2.641l-1.684,1.553 c-0.234,0.229-0.52,0.507-1.089,0.507c-0.7,0-0.863-0.369-0.97-0.748c-0.019-0.065-0.04-0.141-0.071-0.228l-1.206-3.969 l-3.456-1.078c-0.814-0.25-0.923-0.749-0.932-0.951c-0.014-0.336,0.161-0.815,1.074-1.181l14.848-5.729 c0.425-0.166,0.924-0.032,1.212,0.323c0.203,0.249,0.281,0.573,0.215,0.889l-2.565,12.275 C21.168,24.084,20.453,24.204,20.157,24.204z M16,20.155c0.111,0,0.222,0.037,0.313,0.111l3.55,2.862 c0.459,0.219,0.5-0.085,0.557-0.354L22.985,10.5l-0.063-0.081L8.056,16.151c-0.175,0.07-0.29,0.139-0.36,0.19 c0.037,0.018,0.086,0.037,0.147,0.056l3.711,1.158c0.157,0.05,0.281,0.174,0.329,0.332l1.274,4.196 c0.033,0.088,0.061,0.188,0.085,0.272c0.002,0.006,0.004,0.013,0.005,0.019c0.133-0.001,0.203-0.037,0.388-0.218l2.026-1.87 C15.757,20.2,15.878,20.155,16,20.155z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M20.043,13.552c0,0.275-0.225,0.5-0.5,0.5l0,0c-0.275,0-0.5-0.225-0.5-0.5l0,0 c0-0.275,0.225-0.5,0.5-0.5l0,0C19.818,13.052,20.043,13.276,20.043,13.552L20.043,13.552z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2f1ed81a4a78db47c2a166dcdb2949c4.svg";
export { ForwardRef as ReactComponent };